import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowCardActionArea: Components<Theme>['MuiCardActionArea'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // add missing font
      ...theme.typography.body,
    }),
    // remove focus highlight that adds background
    focusHighlight: {
      display: 'none',
    },
  },
};
